module.exports = {
  MODULES_CONFIGURATION_PATH: '__modules_configuration',
  RESOLVE_PROPS_PATH: '__resolve_props',
  MODULE_ASSET_PREFIX: '__remote_module__',
    METRICS: {
    serveModulesMetric: 'module-fetch',
    serveModulesTimeMetric: 'module-fetch-duration',
    corsRejectionMetric: 'cors-rejection'
    },
  MANIFEST_EVENT: 'MANIFEST_EVENT',
  MANIFEST_KEY: 'MANIFEST_KEY',
  MANIFEST_LOADING_KEY: 'loading',
  SCRIPT_TAG: 'SCRIPT',
  CLOSING_SCRIPT_NAME: '-main',
  LOADED_MANIFESTS_KEY: '__manifest',
  REMOTE_MODULE_KEY: '__remote_module',
  REMOTE_MODULE_CLASS_NAME: 'remote-module',
  SCRIPT_ERROR_EVENT_KEY: 'script-error',
  SCRIPT_TYPE:{
    SCRIPT: 'script',
    VENDOR: 'vendor'
  }
};
